import type { CSSProperties } from 'react';

import classNames from 'classnames';

import SimpleModal from '@/ui/SimpleModal';

import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import { confirmActionModalContent } from './ConfirmActionModalElement.css';
import type { ConfirmActionModalElementProps } from './ConfirmActionModalElement.types';

export function ConfirmActionModalElement({
  isOpen,
  onOpenChange,
  onCancel,
  isLoading,
  title,
  message,
  cancelLabel,
  submitLabel,
}: ConfirmActionModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onOpenChange}
      className="shadow-lg overflow-hidden sm:rounded-md"
      style={generatedStyle}
      showCloseButton={false}
      showRoundedBorders={false}
      shouldCloseOnOutsideClick={false}
    >
      <div className={classNames(confirmActionModalContent, 'w-full sm:w-[460px]')}>
        <div className="flex flex-col gap-1 w-full">
          <h1 className="text-gray-900 text-lg font-bold leading-7 w-full">{title}</h1>
          {message && <p className="text-gray-500 text-sm font-normal leading-5 w-full">{message}</p>}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <ButtonElement variant="default" disabled={isLoading} type="button" onClick={onCancel}>
            {cancelLabel}
          </ButtonElement>
          <ButtonElement variant="primary" disabled={isLoading} type="submit">
            {submitLabel}
          </ButtonElement>
        </div>
      </div>
    </SimpleModal>
  );
}
